import { useHistory } from "react-router-dom";
import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import React, { useEffect, useState } from "react";
import { useSausage } from "../../../../providers/SausageContext"
import { useUser } from "../../../../providers/UserContext"
import MpSalesComponent from "../../../../Components/ComponentsMarketplace/MpSalesComponent";

import {
  Container,
  SizeContainer,
  InternalMenu,
} from "./style";
import axios from "axios"

const MpSalesSausage = () => {
  const history = useHistory();
  const { infoSausage, stockSausageMarket, getSausageStockMp } = useSausage()
  const { user, rodada, marketPlace } = useUser()

  const [quantidade, setQuantidade] = useState(0)
  const [preco, setPreco] = useState(0)
  const [quantidadeVenda, setQuantidadeVenda] = useState(0)
  const [precoVenda, setPrecoVenda] = useState(0)
  const [totalReceita, setTotalReceita] = useState(0)

  function handleSales() {

    if (!Number(totalReceita) || Number(totalReceita) === 0) return

    const data = {
      "itens": [
        {
          "preco": Number(precoVenda),
          "produto": {
            "produto": 7,
          },
          "quantidade": Number(quantidadeVenda),
          "total": Number(totalReceita),
        }
      ],
      "rodada": rodada,
      "supermercado": marketPlace,
      "supermercadoUsuario": user,
    }

    axios.post(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/vendasupermercado/cadastrar`, data)
      .then(response => {
        if (response.data.sucesso) {
          alert("Venda efetuada com sucesso")
          setQuantidadeVenda(0)
          setTotalReceita(0)
          setPrecoVenda(0)
          getSausageStockMp()
        }
      })

  }

  useEffect(() => {
    setPreco(infoSausage?.custoUnitario)
    setQuantidade(stockSausageMarket)


  }, [stockSausageMarket, infoSausage])

  useEffect(() => {

    setTotalReceita((precoVenda * quantidadeVenda)?.toFixed(2))

  }, [precoVenda, quantidadeVenda])

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp title="Vendas" pathImg="./images/partnership.svg" />
        <InternalMenu>
          <button className="selected">
            <img src="./images/sausage_orange.svg" alt="sausage" />
          </button>
          <button onClick={() => history.push("/mpSalesChicken")}>
            <img src="./images/chicken_orange.svg" alt="chicken" />
          </button>
          <button onClick={() => history.push("/mpSalesChickenCut")}>
            <img src="./images/chicken_cut_orange.svg" alt="chicken cut" />
          </button>
          <button onClick={() => history.push("/mpSalesFries")}>
            <img src="./images/fries_orange.svg" alt="fries" />
          </button>
        </InternalMenu>
        <MpSalesComponent
          quantidade={quantidade}
          setQuantidade={setQuantidade}
          preco={preco}
          setPreco={setPreco}
          precoVenda={precoVenda}
          setPrecoVenda={setPrecoVenda}
          quantidadeVenda={quantidadeVenda}
          setQuantidadeVenda={setQuantidadeVenda}
          totalReceita={totalReceita}
          handleSales={handleSales}
        />
      </SizeContainer>
    </Container>
  );
};
export default MpSalesSausage;
